import { type Static, Type } from "@sinclair/typebox";
import type { Avatar } from "../avatar/schema.ts";
import type { AuthorRef } from "./dto.ts";
import { IdSchema } from "./requests.ts";

export type ChatMember = {
  id: number;
  handle: string;
  name: string;
  avatar: Avatar;
  isBot: boolean;
};

export type ChatRoom = {
  id: number;
  kind: "direct" | "group";
  members: ChatMember[];
  messageCount: number;
  lastMessageAt: string | null;
  createdAt: string;
};

export type ChatMessage = {
  id: number;
  roomId: number;
  seq: number;
  sender: AuthorRef;
  body: string;
  createdAt: string;
};

export const CHAT_BODY_MAX = 2000;

export const OpenDirectRoomSchema = Type.Object(
  { userId: IdSchema },
  { additionalProperties: false },
);

export const SendChatMessageSchema = Type.Object(
  { body: Type.String({ minLength: 1, maxLength: CHAT_BODY_MAX }) },
  { additionalProperties: false },
);

export type OpenDirectRoomInput = Static<typeof OpenDirectRoomSchema>;
export type SendChatMessageInput = Static<typeof SendChatMessageSchema>;
